export default {
  path: "/query-report",
  name: "QueryReport",
  component: () => import("@/layout/index.vue"),
  // redirect: {
  //     name: "EquipmentMasterData"
  // },
  meta: {
    title: "报表管理",
    icon: "iconfont icon-chaxunbaobiao",
    role: "BACK_MENU7"
  },
  children: [
    {
      path: "/writeXaIn",
      name: "WriteXaIn",
      component: () => import("@/views/reportData/writeXaIn.vue"),
      meta: {
        title: "原材料入库报表",
        role: "BACK_MENU7_M1"
      }
    },
    {
      path: "/writeXaOut",
      name: "WriteXaOut",
      component: () => import("@/views/reportData/writeXaOut.vue"),
      meta: {
        title: "原材料出库报表",
        role: "BACK_MENU7_M2"
      }
    },
    {
      path: "/inventoryXAContrast",
      name: "InventoryXAContrast",
      component: () => import("@/views/reportData/inventoryXAContrast.vue"),
      meta: {
        title: "原材料出入库对比",
        role: "BACK_MENU7_M3"
      }
    },
    {
      path: "/inventoryXADate",
      name: "InventoryXADate",
      component: () => import("@/views/reportData/inventoryXADate.vue"),
      meta: {
        title: "原材料出入库周转",
        role: "BACK_MENU7_M4"
      }
    },
    {
      path: "/materialChange",
      name: "MaterialChange",
      component: () => import("@/views/reportData/materialChange.vue"),
      meta: {
        title: "物料状态变更报表",
        role: "BACK_MENU7_M5"
      }
    },
    {
      path: "/expirationReminder",
      name: "ExpirationReminder",
      component: () => import("@/views/reportData/expirationReminder.vue"),
      meta: {
        title: "保质期到期提醒",
        role: "BACK_MENU7_M6"
      }
    },
    {
      path: "/safetyInventory",
      name: "SafetyInventory",
      component: () => import("@/views/reportData/safetyInventory.vue"),
      meta: {
        title: "安全库存查询",
        role: "BACK_MENU7_M7"
      }
    },
    {
      path: "/inventoryAge",
      name: "InventoryAge",
      component: () => import("@/views/reportData/inventoryAge.vue"),
      meta: {
        title: "库龄分析报表",
        role: "BACK_MENU7_M8"
      }
    },
    // {
    //     path: "/auxiMaterial",
    //     name: "AuxiMaterial",
    //     component: () => import("@/views/reportData/auxiMaterial.vue"),
    //     meta: {
    //         title: "领用申请查询",
    //         role: "BACK_MENU7_M9"
    //     }
    // },
    {
      path: "/confluence",
      name: "Confluence",
      component: () => import("@/views/reportData/confluence.vue"),
      meta: {
        title: "收发存汇总表报表",
        role: "BACK_MENU7_M10"
      }
    },
    {
      path: "/stockOtherRecord",
      name: "StockOtherRecord",
      component: () => import("@/views/reportData/stockOtherRecord.vue"),
      meta: {
        title: "杂入杂出报表",
        role: "BACK_MENU7_M11"
      }
    },
    {
      path: "/writeXa",
      name: "SriteXa",
      component: () => import("@/views/reportData/writeXa.vue"),
      meta: {
        title: "回写XA系统报表",
        role: "BACK_MENU7_M12"
      }
    },
    {
      path: "/stockQualityWait",
      name: "StockQualityWait",
      component: () => import("@/views/reportData/stockQualityWait.vue"),
      meta: {
        title: "质量未检报表",
        role: "BACK_MENU7_M13"
      }
    },
    {
      path: "/writeXaAchievements",
      name: "WriteXaAchievements",
      component: () => import("@/views/reportData/writeXaAchievements.vue"),
      meta: {
        title: "绩效统计",
        role: "BACK_MENU7_M14"
      }
    },
    {
      path: "/ReportDirectMaterial",
      name: "ReportDirectMaterial",
      component: () => import("@/views/reportData/ReportDirectMaterial.vue"),
      meta: {
        title: "Direct Material",
        role: "BACK_MENU7_M15"
      }
    },
    {
      path: "/ShippingBindingRecord",
      name: "ShippingBindingRecord",
      component: () => import("@/views/reportData/ShippingBindingRecord.vue"),
      meta: {
        title: "出货绑定记录报表",
        role: ""
      }
    },
    {
      path: "/MaterialBindingRecord",
      name: "MaterialBindingRecord",
      component: () => import("@/views/reportData/MaterialBindingRecord.vue"),
      meta: {
        title: "箱物料绑定记录报表",
        role: ""
      }
    },
    // {
    //     path: "/ReportIndirectMaterial",
    //     name: "ReportIndirectMaterial",
    //     component: () => import("@/views/reportData/ReportIndirectMaterial.vue"),
    //     meta: {
    //         title: "Indirect Material",
    //         role: 'BACK_MENU7_M16'
    //     }
    // },
    // {
    //     path: "/ReportLSBCycleCount",
    //     name: "ReportLSBCycleCount",
    //     component: () => import("@/views/reportData/ReportLSBCycleCount.vue"),
    //     meta: {
    //         title: "LSB Cycle Count",
    //         role: 'BACK_MENU7_M17'
    //     }
    // }
  ]
};
